// HomePage.js
import React, { useState } from "react";
import useAuth from "./Hooks/useAuth";
import useDeployments from "./Hooks/useDeployments";
import DeploymentCard from "./Components/MonitorDeployments/DeploymentCard";
import PageHeader from "./Components/Navigation/PageHeader";
import SkeletonCard from "./Components/MonitorDeployments/DeploymentCardSkeleton";
import NoDeploymentsMessage from "./Components/MonitorDeployments/NoDeploymentsMessage";
import useNotificationPermission from "./Hooks/NotificationPermission";
import FaviconBadge from "./Components/FaviconBadge";
import "react-toastify/dist/ReactToastify.css";

function HomePage() {
  const { user, signIn } = useAuth();
  const [filter, setFilter] = useState("all"); // The filter state
  const [searchTerm, setSearchTerm] = useState("");
  const [processingRestore, setProcessingRestore] = useState(false);
  
  const { deployments, initialLoad, setDeployments, completedDeploymentsCount, archiveCompletedDeployments } = useDeployments(user);

  useNotificationPermission();

  
  // Filter deployments based on search term and selected filter
  const filteredDeployments = deployments
    .filter((deployment) => {
      if (filter === "running") {
        return deployment.percentComplete < 100; // Running deployments
      } else if (filter === "complete") {
        return deployment.percentComplete === 100; // Completed deployments
      } else {
        return true; // Show all
      }
    })
    .filter(
      (deployment) =>
        deployment.companyCode
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        deployment.machineName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        deployment.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        deployment.companyName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
    );


    


  return (
    <>
      <title>JimmyBot - Active Deployments</title>
      <PageHeader
        iconName="deployments"
        placeholderText="Search by Company Name, Client Code or User"
        user={user}
        signIn={signIn}
        setSearchTerm={setSearchTerm}
        filter={filter}
        setFilter={setFilter}
        showArchive={false}
        title="Monitor Active Deployments"
        completedDeploymentsCount={completedDeploymentsCount}
        archiveCompletedDeployments={archiveCompletedDeployments}
      />
      <div
        style={{
          padding: "16px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "space-around",
            width: "100%",
          }}
        >
          {initialLoad || processingRestore ? (
            Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                style={{
                  flex: "0 1 375px",
                }}
              >
                <SkeletonCard />
              </div>
            ))
          ) : filteredDeployments.length > 0 ? (
            filteredDeployments.map((deployment) => (
              <div
                key={deployment.id}
                style={{
                  flex: "0 1 375px",
                }}
              >
                <DeploymentCard
                  deployment={deployment}
                  setDeployments={setDeployments}
                  setProcessingRestore={setProcessingRestore}
                />
              </div>
            ))
          ) : (
            <NoDeploymentsMessage Message="No Active Deployments" />
          )}
        </div>
      </div>

      <FaviconBadge count={filteredDeployments.length} />
    </>
  );
}

export default HomePage;
